import { useState } from 'react'
import Button from '@material-ui/core/Button'
import AddOutlined from '@material-ui/icons/AddOutlined'
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'

import { ActionButton } from 'components/common/buttons'
import { TableComponent } from 'components/common/table-components'

import { get, isEmpty } from 'lodash'
import { snakifyKeys } from 'helpers/formatters'
import SearchComponent from 'components/common/search'
import DialogPrompt from 'components/DialogPrompt'
import { Toast } from 'Snackbar/useToast'
import AddContact from './AddContact'
import facilities from 'Services/facilities'
import useFetchData from 'hooks/fetch-data'
import TablePagination from '@material-ui/core/TablePagination'

const ContactList = ({ obj }) => {
  const [searchString, setSearchString] = useState('')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [pageIndex, setPageIndex] = useState(1)
  const [addContactOpen, setAddContactOpen] = useState(false)
  const [isEditOpen, setEditOpen] = useState(false)
  const [deleteContactOpen, setDeleteContactOpen] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [anchorObj, setAnchorObj] = useState({})

  const payload = { pagesize: pageSize, pageindex: pageIndex, search_string: isEmpty(searchString) ? null : searchString, client_company_id: get(obj, 'clientCompanyId', null) }
  const { loading, data: contactData, reFetch } = useFetchData({ fetch: facilities.getAllSiteContacts, payload, formatter: d => get(d, 'data', []) })

  const columns = [
    { name: 'Title', accessor: 'sitecontactTitle' },
    { name: 'Name', accessor: 'sitecontactName' },
    { name: 'Email', accessor: 'sitecontactEmail' },
    { name: 'Phone Number', accessor: 'sitecontactPhone' },
    {
      name: 'Actions',
      render: d => (
        <div className='d-flex align-items-center'>
          <ActionButton action={e => handleAction(e, 'EDIT', d)} icon={<EditOutlinedIcon fontSize='small' />} tooltip='EDIT' />
          <ActionButton action={e => handleAction(e, 'DELETE', d)} icon={<DeleteOutlineOutlinedIcon fontSize='small' style={{ color: '#FF0000' }} />} tooltip='DELETE' />
        </div>
      ),
    },
  ]

  const handleAction = async (event, type, data) => {
    event.stopPropagation()
    setAnchorObj(data)
    if (type === 'DELETE') setDeleteContactOpen(true)
    if (type === 'EDIT') setEditOpen(true)
  }

  const deleteContact = async () => {
    const { sitecontactId } = anchorObj
    try {
      setDeleteLoading(true)
      const res = await facilities.deleteSiteContact(snakifyKeys(sitecontactId))
      if (res.success > 0) {
        Toast.success(`Contact deleted successfully !`)
        reFetch()
      } else Toast.error(res.message || 'Something went wrong !')
      setDeleteLoading(false)
      setDeleteContactOpen(false)
    } catch (error) {
      setDeleteLoading(false)
      setDeleteContactOpen(false)
      Toast.error('Something went wrong !')
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    setPageIndex(newPage + 1)
  }

  const handleChangeRowsPerPage = event => {
    setPageSize(parseInt(event.target.value, 10))
    setPage(0)
    setPageIndex(1)
  }

  const postSearch = () => {
    setPage(0)
    setPageIndex(1)
  }

  return (
    <div style={{ background: '#fff', height: 'calc(100vh - 180px)', width: '100%', margin: '10px 0 20px 0px' }}>
      <div className='d-flex justify-content-between align-items-center' style={{ width: '100%', marginBottom: '20px' }}>
        <div className='d-flex align-items-center'>
          <Button size='small' onClick={() => setAddContactOpen(true)} startIcon={<AddOutlined />} variant='contained' color='primary' className='nf-buttons' disableElevation>
            Add Contact
          </Button>
        </div>
        <SearchComponent placeholder='Search' postClear={postSearch} postSearch={postSearch} searchString={searchString} setSearchString={setSearchString} />
      </div>
      <div className='table-responsive dashboardtblScroll' id='style-1' style={{ height: 'calc(100% - 95px)' }}>
        <TableComponent loading={loading} columns={columns} data={get(contactData, 'list', [])} />
      </div>
      {!isEmpty(get(contactData, 'list', [])) && <TablePagination rowsPerPageOptions={[20, 40, 60, 80, 100]} component='div' count={get(contactData, 'listsize', 0)} rowsPerPage={pageSize} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />}
      {addContactOpen && <AddContact clientCompanyId={get(obj, 'clientCompanyId', null)} reFetch={reFetch} open={addContactOpen} onClose={() => setAddContactOpen(false)} />}
      {isEditOpen && <AddContact clientCompanyId={get(obj, 'clientCompanyId', null)} obj={anchorObj} isEdit reFetch={reFetch} open={isEditOpen} onClose={() => setEditOpen(false)} />}
      <DialogPrompt title='Delete Contact' text='Are you sure you want to delete the contact ?' open={deleteContactOpen} ctaText='Delete' actionLoader={deleteLoading} action={deleteContact} handleClose={() => setDeleteContactOpen(false)} />
    </div>
  )
}

export default ContactList
